var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGirl(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.356 5.86085C22.5694 12.1162 23.4169 18.2135 18.4771 20.6318C16.1182 21.7717 10.0967 22.5132 7.28195 17.0486C3.24801 12.7795 1.95702 9.55046 6.18117 5.96293C10.4406 2.34675 14.7553 0.683881 18.356 5.86085Z",
    fill: "#F4BA92"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.37745 14.075C9.44691 13.3333 9.68757 12.6179 10.0805 11.9851C10.4734 11.3522 11.0079 10.8192 11.6418 10.428L11.6938 10.4011C16.8003 7.19647 14.2593 0.551805 8.44894 2.26672C7.65568 2.49201 6.77943 2.6717 5.97186 3.15261C-0.427099 7.04476 2.92193 13.869 2.70109 15.9891C2.65256 16.578 2.51656 17.1564 2.29756 17.7053C1.81622 18.9268 6.08216 23.0989 10.0805 20.4377C10.703 20.0192 9.84048 17.6704 8.40269 17.7131C6.9649 17.7557 9.24759 15.1592 9.36397 14.2044L9.37745 14.075Z",
    fill: "#141719"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0034 12.227C13.0034 12.227 12.1593 11.8173 11.6688 12.6684",
    stroke: "#141719",
    strokeWidth: 0.750331,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0098 9.95351C17.0098 9.95351 17.0032 8.93824 17.7644 9.04986",
    stroke: "#141719",
    strokeWidth: 0.750331,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4297 13.5C19.0598 13.7919 19.0657 14.356 18.7563 14.6949",
    stroke: "#CC7567",
    strokeWidth: 0.750331,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7865 13.9976C13.7865 13.9976 13.077 13.5373 12.7608 14.8731",
    stroke: "#141719",
    strokeWidth: 0.750331,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0287 10.7437C19.0287 10.7437 18.3192 10.2834 18.003 11.6191",
    stroke: "#141719",
    strokeWidth: 0.750331,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3795 19.2814C16.8983 19.5618 17.5198 19.6265 18.0831 19.1848C18.3093 19.0071 18.4888 18.7769 18.6061 18.5141C18.7233 18.2514 18.7747 17.964 18.7559 17.6769C17.8489 18.0181 17.0349 18.5677 16.3795 19.2814Z",
    fill: "#F97D7C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5678 17.7959C15.4966 17.9019 15.4565 18.0257 15.4519 18.1534C15.4473 18.281 15.4785 18.4074 15.5418 18.5183C15.7513 18.8425 16.0425 19.106 16.386 19.2821C17.0437 18.5664 17.8631 18.0183 18.7757 17.6835C18.7745 16.9259 18.6007 16.4075 18.2519 16.3711C16.8115 16.2165 15.9323 17.238 15.5678 17.7959Z",
    fill: "#CC4744"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4408 15.7805C11.1344 16.8519 10.9429 18.2176 9.9942 18.8269C9.04547 19.4363 7.70979 19.1048 7.0162 18.0333C6.3226 16.9619 6.5126 15.5961 7.46132 14.9867C8.41005 14.3773 9.74415 14.7241 10.4408 15.7805Z",
    fill: "#F4BA92"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2821 6.99789C12.2821 6.99789 15.4403 7.9242 18.1177 6.96219C18.9525 6.67811 18.8686 5.78411 18.8151 4.90868C18.5628 1.61081 11.6788 -0.0392147 6.61183 2.81544C0.659812 6.1414 12.2821 6.99789 12.2821 6.99789Z",
    fill: "#141719"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M7.805 16.5345C7.805 16.5345 8.00915 15.6536 8.9227 16.1506C9.53484 16.7624 8.89411 17.3561 8.89411 17.3561C9.00861 17.4902 9.15889 17.589 9.32741 17.6409C9.49592 17.6928 9.67573 17.6957 9.84583 17.6493",
    stroke: "#CC7567",
    strokeWidth: 0.800863,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3043 9.18704C20.3043 9.18704 20.774 4.6773 17.5157 3.32332C15.0454 2.29623 18.1356 6.96432 18.1356 6.96432C18.1356 6.96432 19.0919 7.62741 20.3043 9.18704Z",
    fill: "#141719"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGirl);
export default __webpack_public_path__ + "static/media/girl.cede9c95574ff3812b32a990615974d6.svg";
export { ForwardRef as ReactComponent };